import {type RootState } from '../store';

export const selectCurrentRoute = (state: RootState) => state.router.url;
export const selectQueryParams = (state: RootState) => state.router.queryParams;
export const selectRouteParams = (state: RootState) => state.router.params;
